// extracted by mini-css-extract-plugin
export default {"skeleton":"UnityHubNetworkingItemSkeleton_skeleton__XDO8t"};